import { alpha } from "@mui/material"
import { lightBlue } from "../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(() => ({
  detailsButton: {
    "&:focus": {
      border: "none",
      outline: `1px solid ${lightBlue[400]}`,
      boxShadow: `0 0 0 3px ${alpha(lightBlue[200], 0.2)} !important`
    }
  }
}))
